export const STEP_OPTIONS = [
  { value: "", label: "--- Select ---" },
  { value: "1", label: "Step 1: Ready for Isolation" },
  { value: "2", label: "Step 2: Isolation" },
  { value: "3", label: "Step 3: RNA Quantification" },
  { value: "4", label: "Step 4: Reverse Transcription" },
  { value: "5", label: "Step 5: cDNA Quantification" },
  { value: "6", label: "Step 6: qPCR Control Plate" },
];

export const NEXT_STEP_ACTION: Record<string, string> = {
  "1": "Begin Isolation",
  "2": "Begin RNA Quantification",
  "3": "Begin Reverse Transcription",
  "4": "Begin cDNA Quantification",
  "5": "Begin QPCR Control Plate",
  "6": "",
};

export const INITIAL_SEARCH_CRITERIA = {
  batchName: "",
  batchCode: "",
  runDate: "",
  plateBarcodeNo: "",
  stepNumber: "",
};

export const INITIAL_POST_DATA = {
  oncologyBatchId: 0,
  batchName: "",
  batchCode: "",
  runDate: "",
  plateBarcodeNo: "",
  stepNumber: "",
};
